import { Injectable, inject } from '@angular/core';
import { Client } from '../models/cliente.interface';
import { UserRoleStore } from '@/app/core/states/user-role-stare/client-role-state.store';
import { Observable, of } from 'rxjs';
import { ClientsService } from '../../clientes/services/clients.service';

const STORAGE_KEY = 'currentClient';

@Injectable({ providedIn: 'root' })
export class ClientSessionService {
  private userState = inject(UserRoleStore);
  private clientsService = inject(ClientsService);

  /** Guarda el cliente en localStorage */
  setClient(client: Client): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(client));
  }

  /** Recupera el cliente desde localStorage, o null si no existe */
  getClient(): Client | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) as Client : null;
  }

  /** Obtiene el cliente COMPLETO desde los datos del usuario logueado */
  getClientFromUser(): Observable<Client | null> {
    const user = this.userState.user();
    const clientId = user?.attributes?.['publicId'];

    if (!clientId) {
      return of(null);
    }

    return this.clientsService.getClient(clientId);
  }
}
